/**
 * Booking-step tracking beacon (Oct 21 2026). Logged-in users only.
 * trackBookingStep('format_pick', { listingId, format }) -> POST /api/bf.
 * Also sends a GA4 event (bf_<step>) when gtag is loaded.
 */
import { readStored } from './signupSource';

let uid = null;
const seen = {};
let pending = [];
const LID_RE = /\/l\/(?:[^/]+\/)?([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/;
const listingFromPath = () => {
  try {
    const m = LID_RE.exec(window.location.pathname || '');
    return m ? m[1] : null;
  } catch (e) {
    return null;
  }
};
export const setBookingFunnelUser = id => {
  uid = typeof id === 'string' ? id : id?.uuid || null;
  if (uid && pending.length) {
    const q = pending;
    pending = [];
    q.forEach(([s, o, at]) => {
      if (Date.now() - at < 20000) trackBookingStep(s, o);
    });
  }
};

/** Route-based steps from the page-view beacon. */
export const trackBookingRoute = (pathname = '', search = '') => {
  if (!/^\/l\//.test(pathname) || /^\/l\/(new|draft)/.test(pathname)) return;
  const m = LID_RE.exec(pathname);
  if (!m) return;
  let mode = null;
  try {
    mode = new URLSearchParams(search).get('mode');
  } catch (e) {
    mode = null;
  }
  const tail = pathname.slice(pathname.indexOf(m[1]) + m[1].length).replace(/\/$/, '');
  if (tail === '') trackBookingStep('profile_view', { listingId: m[1], once: true });
  else if (tail === '/book') {
    trackBookingStep('booking_page', { listingId: m[1], mode, once: true });
    // Profile / card CTAs are links straight to /book?mode=now|later: count the tap from the mode.
    if (mode === 'now') trackBookingStep('start_now_tap', { listingId: m[1], once: true });
    else if (mode === 'later' || mode === 'next') trackBookingStep('book_time_tap', { listingId: m[1], mode, once: true });
  }
  else if (tail === '/checkout') trackBookingStep('checkout_view', { listingId: m[1], once: true });
};

export const trackBookingStep = (step, opts = {}) => {
  if (typeof window === 'undefined') return;
  if (!uid) {
    if (pending.length < 20) pending.push([step, opts, Date.now()]);
    return;
  }
  const { listingId, format, error, mode, once = false } = opts;
  const l = (typeof listingId === 'string' ? listingId : listingId?.uuid) || listingFromPath();
  const key = `${step}|${l}|${format || ''}`;
  if (once) {
    if (seen[key] && Date.now() - seen[key] < 30000) return;
    seen[key] = Date.now();
  }
  let src = null;
  try {
    const s = readStored();
    src = s ? { first: s.first, last: s.last } : null;
  } catch (e) {
    src = null;
  }
  const body = { s: step, uid, l, f: format || null, e: error ? String(error).slice(0, 60) : null, m: mode || null, src };
  try {
    window.fetch('/api/bf', {
      method: 'POST',
      credentials: 'include',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(() => {});
  } catch (e) {
    // ignore
  }
  try {
    if (typeof window.gtag === 'function') window.gtag('event', `bf_${step}`, { listing_id: l, format: format || undefined });
  } catch (e) {
    // ignore
  }
};
